module.exports = __webpack_public_path__ + "static/media/KioskItemDetailsScreen.505d5ab6.png";